<template>
  <div class="about2">
    <div>
      文衡聖帝，天上武曲星宿托胎化生，誕降於南宋孝宗隆興元年(西元一一六三年)九月二十一日，父黃從、世居福建省汀州縣，喜獲麟兒、滿月後取名「黃倪」另名「黃儀」。
    </div>
    <div>&nbsp;</div>
    <div>
      黃倪幼習四書五經，資質穎慧，十六稚齡已學貫經文，二十三歲受聘文書三年，念茲文武兼備之質，棄文從武，跟隨一名武官習練，三十一歲受部將之職，三十三歲升為子將，衣錦榮歸，父親殷囑「青山如果在、仁義不可無」，時日以此自勉。翌年山西匪亂，遣黃倪營騎前往平亂，及至平陽，黃倪為亂賊所擒，不屈而咬舌自盡，忠義上感蒼雲，歸位仙班，三年後敕封「文衡聖帝」尊號，從而鎮守關帝山，七年後，老景子於此山入籍。
    </div>
    <div>&nbsp;</div>
    <div>
      文衡聖帝鎮山五十年，奉旨下凡宣化，適值黃姓血親孫輩蹇於家運，求助先輩冥陰，文衡聖帝藉機顯化，孫輩尊為「老祖」，奉為族裔守護之神，文衡聖帝凡降施化，首於黃族開道立教，時顯其靈，恩德駢臻，迄於清初，列於「黃家祖佛」，渥享馨香俎豆。康熙五年(西元一六六六年)，文衡聖帝雲遊來台，屬意瀛島為弘教之地，及至乾隆年間，黃姓族裔渡海屯墾，迎奉祖佛金身隨行護佑，於安平登岸，擇居前甲，此時前甲墾戶有黃、李、杜三姓，自祖佛駐駕，神庥所庇，生聚日繁，遂而香火漸興，虔祀之情，可表天地。
    </div>
    <div>&nbsp;</div>
    <div>
      文衡聖帝蒞台開教，德澤覃敷，功參天地，民國五十三年以其施化之功，神格晉陞，接掌關帝殿主祀之位「文衡聖帝」，民有所禱、事無不應、濟世福民、神威浩蕩。
    </div>
    <div>&nbsp;</div>
    <div>
      所謂「聖而威神」，聖者所以垂視訓民、神者所以濟世護民也。我文衡聖帝黃公倪，幼本詩書之教、庭訓之誨、長受武技之藝、兵陣之術，文武雙全，仁義可風，全忠以殉國，冊錄仙籍，昇化而威神，扶世佑民，我輩信民事神之道，惟誠惟敬，一則以崇聖帝忠義之節，一則以謝黃公覆佑之恩，恭呈春秋血食之祀，敬祈風調雨順、國泰民安。
    </div>
  </div>
</template>

<script>
export default {
  name: 'About2',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped></style>
